var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.446167,
    width: 41,
    height: 40,
    rx: 8,
    fill: "#F9E1C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.6962C15 15.1049 15.6321 13.5787 16.7574 12.4535C17.8826 11.3283 19.4087 10.6962 21 10.6962C22.5913 10.6962 24.1174 11.3283 25.2426 12.4535C26.3679 13.5787 27 15.1049 27 16.6962C27 18.2875 26.3679 19.8136 25.2426 20.9388C24.1174 22.064 22.5913 22.6962 21 22.6962C19.4087 22.6962 17.8826 22.064 16.7574 20.9388C15.6321 19.8136 15 18.2875 15 16.6962ZM27.3656 11.4462C25.8516 9.61335 23.5641 8.44617 21 8.44617C18.4359 8.44617 16.1484 9.61335 14.6344 11.4462H12C10.3453 11.4462 9 12.7915 9 14.4462V29.4462C9 31.1009 10.3453 32.4462 12 32.4462H30C31.6547 32.4462 33 31.1009 33 29.4462V14.4462C33 12.7915 31.6547 11.4462 30 11.4462H27.3656ZM22.875 18.9462C22.875 18.4493 22.6828 17.9993 22.3641 17.6618L23.9391 13.9915C24.1031 13.6118 23.925 13.1712 23.5453 13.0071C23.1656 12.843 22.725 13.0212 22.5609 13.4009L20.9859 17.0712C19.9547 17.0759 19.125 17.9149 19.125 18.9462C19.125 19.9821 19.9641 20.8212 21 20.8212C22.0359 20.8212 22.875 19.9821 22.875 18.9462Z",
    fill: "#EC9736"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.3d47f951232159021ef5e8e097a7b410.svg";
export { ForwardRef as ReactComponent };